<template>
	<div class="container">
		<div class="content">
			<div class="card">
				<!--구매 탭-->
				<div v-if="selectedTab === 1">
					<h3 class="title">P2P</h3>
					<div class="d_flex align_items_end justify_between mb_8">
						<div class="d_flex">
							<div class="more_button_wrap d_flex">
								<select class="more_button tac" v-model="status" tabindex="-1">
									<option value="">{{ $t('c2c.status1') }}</option>
									<option value="OPEN">{{ $t('c2c.OPEN') }}</option>
									<option value="COMPLETED">{{ $t('c2c.COMPLETED') }}</option>
									<option value="CANCELED">
										{{ $t('c2c.status4') }}
									</option>
								</select>
								<span class="select_icon"></span>
								<div class="refresh_button mr_8">
									<span id="refresh" @click="reset" class="refresh"></span>
								</div>
							</div>
						</div>
						<button
							id="regist"
							:class="[
								{ selected: selectedTab === 2 },
								'sell',
								'green',
								'd_flex',
								'align_items_center',
							]"
							@click="tabSelect(2)"
						>
							<img
								class="add_sell"
								src="@/assets/images/icon/add_sell.png"
								alt=""
							/>
							{{ $t('c2c.sell.title') }}
						</button>
					</div>
					<div class="search_area_1" @click="modalSearch = true">
						<div v-if="!selectedAsset">
							<span class="body_l">{{
								$t('input.placeholder.search_assets')
							}}</span>
							<a class="search_icon SEARCH"></a>
						</div>
						<div v-else>
							<div class="d_flex align_items_center">
								<span :class="'coin_icon mb_0 ' + selectedAsset.code"></span>
								<span class="coin_name fc_black">{{
									selectedAsset.code + ' ' + selectedAsset.title
								}}</span>
							</div>
						</div>
					</div>
					<ul class="list_wrap">
						<li class="base" v-for="item in dealList" :key="item.seq">
							<span class="list_num_m mb_4">{{ item._no }}</span>
							<div class="box_1 d_flex justify_between mb_8">
								<span>
									{{ ' ' + $dayjs(item.regdate).format('YYYY.MM.DD HH:mm:ss') }}
								</span>
								<div class="d_flex justify_between status_area">
									<div
										:class="[
											{
												green: item.status === 'OPEN',
												gray: item.status === 'CANCELED',
												black: item.status === 'COMPLETED',
											},
											,
											'd_flex',
											'align_items_center',
											'status',
										]"
									>
										<span class="icon"></span
										><span>{{
											item.status === 'OPEN'
												? $t('c2c.OPEN')
												: item.status === 'CANCELED'
												? $t('c2c.status4')
												: $t('c2c.COMPLETED')
										}}</span>
									</div>
								</div>
							</div>
							<div class="d_flex mb_8">
								<div class="box_2 mr_16">
									{{ $t('c2c.th1') }}
									<div class="asset_box">
										<span :class="[item.source_asset_code, 'small']"></span>
										<p class="code mr_4">{{ item.source_asset_code }}</p>
										<p class="name">{{ item.source_asset_title }}</p>
									</div>
								</div>
								<div class="box_3">
									{{ $t('c2c.th4') }}
									<div class="asset_box">
										<span :class="[item.target_asset_code, 'small']"></span>
										<p class="code mr_4">{{ item.target_asset_code }}</p>
										<p class="name">{{ item.target_asset_title }}</p>
									</div>
								</div>
							</div>
							<div class="box_4 mb_8">
								{{ $t('c2c.th2') }}
								<div class="num_unit type01">
									<p class="num">{{ item.potential_source_amount }}</p>
									<p class="unit">{{ item.source_asset_code }}</p>
								</div>
							</div>
							<div class="box_5 mb_4">
								{{ $t('c2c.th3') }}
								<p class="amount">
									1
									{{
										item.source_asset_code +
										' = ' +
										item.min_price +
										'' +
										item.target_asset_code
									}}
								</p>
							</div>
							<div class="box_6 mb_8" v-if="item.use_source_min_amount === 'Y'">
								<p>{{ $t('c2c.sell.head6') }}</p>
								<p class="amount">{{ item.source_min_amount }}</p>
							</div>
							<span class="user_id">{{
								item.user_id !== 'null' ? item.user_id : ''
							}}</span>
							<button
								id="purchaseRequest"
								class="button_bg_red absolute_button"
								:disabled="item.status !== 'OPEN'"
								@click="createBuyHandler(item)"
							>
								{{ $t('c2c.buy.title') }}
							</button>
						</li>
					</ul>
					<pagination
						:totalCount="pageNavigation.total_count"
						:totalPage="pageNavigation.total_page"
						:curPage="pageNavigation.cur_page"
						:point="pageNavigation.point"
						:firstPage="pageNavigation.first_page"
						:lastPage="pageNavigation.last_page"
						@change="pageChangeHandler"
					></pagination>
				</div>
				<!--판매 탭-->
				<div v-if="selectedTab === 2">
					<C2cSellM
						@success="selectedTab = 1"
						@cancel="selectedTab = 1"
					></C2cSellM>
				</div>
			</div>
		</div>
	</div>
	<ModalViewM v-if="modalSearch" @closeModal="modalSearch = false">
		<AssetSearchM :markets="markets" @selectAsset="selectAsset"></AssetSearchM>
	</ModalViewM>
	<ModalViewM v-if="modalAccountCheck" @closeModal="modalAccountCheck = false">
		<template #title>
			<h3 class="modal_title_m">{{ $t('c2c.check.title') }}</h3>
		</template>
		<CheckAccountM
			:source-asset-seq="selectedMarket.source_asset_seq"
			:target-asset-seq="selectedMarket.target_asset_seq"
			@createAccount="createAccount"
		></CheckAccountM>
	</ModalViewM>
	<ModalViewM v-if="modalBuy" @closeModal="modalBuy = false">
		<C2cBuyM
			:deal-seq="selectedDealSeq"
			@closeParentModal="modalBuy = false"
			@close="closeBuyModal"
		></C2cBuyM>
	</ModalViewM>
	<ModalViewM v-if="modalAccountRegist" @closeModal="closeRegistModal">
		<template #title>
			<h3 class="modal_title_m tal">
				{{ $t('rtr_wallet_account-assets.title3') }}
			</h3>
		</template>
		<AccountRegister
			@closeRegist="closeRegistModal"
			:asset-info="createAsset"
		></AccountRegister>
	</ModalViewM>
	<Tutorial v-if="showTutorial" @close="showTutorial = false"></Tutorial>
</template>

<script>
import pagination from '@/components/Pagination';
import AssetSearchM from '@/components/User/Pay/AssetSearch.m';
import ModalViewM from '@/components/Layout/ModalView.m';
import CheckAccountM from '@/components/User/Pay/CheckAccount.m';
import C2cBuyM from '@/components/User/Pay/C2cBuy.m';
import C2cSellM from '@/components/User/Pay/C2cSell.m';
import AccountRegister from '@/components/AccountRegister';
import '@/assets/css/c2c.m.css';
import { fetchPrivateMarketDeal, fetchPrivateMarkets } from '@/api/market';
import { commonError } from '@/common/dialog';
import { mapGetters } from 'vuex';
import { uniqBy } from 'lodash';
import Tutorial from '@/components/Tutorial';
import Cookies from 'js-cookie';

export default {
	name: 'C2c.m',
	components: {
		pagination,
		AssetSearchM,
		ModalViewM,
		CheckAccountM,
		C2cBuyM,
		C2cSellM,
		AccountRegister,
		Tutorial,
	},
	data() {
		return {
			sourceAssetSeq: null,
			status: '',
			markets: [],
			dealList: [],
			pageNavigation: {},
			curPage: 1,
			listCount: 10,
			modalSearch: false,
			modalAccountCheck: false,
			modalAccountRegist: false,
			modalBuy: false,
			selectedTab: 1,
			selectedMarketSeq: null,
			selectedDealSeq: null,
			createAsset: {},
			tour: null,
			showTutorial: false,
		};
	},
	computed: {
		...mapGetters('account', ['accounts']),
		...mapGetters('assets', ['assets', 'registedAssets']),
		sourceAssets() {
			const result = [];
			this.markets.forEach(market => {
				const asset = this.registedAssets.find(asset => {
					return asset.seq === market.source_asset_seq;
				});
				if (asset) result.push(asset);
			});
			return uniqBy(result, 'seq');
		},
		selectedMarket() {
			return this.markets.find(item => {
				return item.seq === this.selectedMarketSeq;
			});
		},
		selectedAsset() {
			return this.assets.find(item => {
				return item.seq === this.sourceAssetSeq;
			});
		},
	},
	watch: {
		sourceAssetSeq() {
			this.refreshPrivateDealList();
		},
		status() {
			this.refreshPrivateDealList();
		},
		selectedTab(value) {
			if (value === 1) {
				this.refreshPrivateDealList();
			}
			window.scrollTo(0, 0);
		},
	},
	created() {
		this.init();
	},
	methods: {
		tabSelect(e) {
			this.selectedTab = e;
		},
		init() {
			Promise.all([this.loadPrivateMarkets(), this.loadPrivateDealList()]);
		},
		refreshPrivateDealList() {
			this.curPage = 1;
			this.loadPrivateDealList();
		},
		async loadPrivateMarkets() {
			const { data } = await fetchPrivateMarkets().catch(commonError);
			this.markets = data.filter(item => {
				return item.is_active === 'Y';
			});
		},
		async loadPrivateDealList() {
			const params = {
				status: this.status,
				source_asset_seq: this.sourceAssetSeq,
				page: this.curPage,
				list_count: this.listCount,
			};
			const { data, page_navigation } = await fetchPrivateMarketDeal(
				params,
			).catch(commonError);
			this.dealList = data;
			this.pageNavigation = page_navigation;
		},
		pageChangeHandler(pageNo) {
			this.curPage = pageNo;
			this.loadPrivateDealList();
		},
		createBuyHandler(deal) {
			if (deal) {
				this.selectedMarketSeq = deal.market_seq;
				this.selectedDealSeq = deal.seq;
			}
			if (!this.checkAccounts()) {
				this.modalAccountCheck = true;
			} else {
				this.modalBuy = true;
			}
		},
		checkAccounts() {
			const sourceAccount = this.accounts.find(account => {
				return account.asset_seq === this.selectedMarket.source_asset_seq;
			});
			const sourceAsset = this.registedAssets.find(asset => {
				return asset.seq === this.selectedMarket.source_asset_seq;
			});
			const targetAccount = this.accounts.find(account => {
				return account.asset_seq === this.selectedMarket.target_asset_seq;
			});
			const targetAsset = this.registedAssets.find(asset => {
				return asset.seq === this.selectedMarket.target_asset_seq;
			});
			return !(
				(!sourceAccount && sourceAsset.is_active === 'Y') ||
				(!targetAccount && targetAsset.is_active === 'Y')
			);
		},
		selectAsset(assetSeq) {
			this.sourceAssetSeq = assetSeq;
			this.modalSearch = false;
		},
		reset() {
			this.sourceAssetSeq = null;
			this.status = '';
			this.curPage = 1;
		},
		createAccount(seq) {
			this.createAsset = this.assets.find(item => {
				return item.seq === seq;
			});
			this.modalAccountCheck = false;
			this.modalAccountRegist = true;
		},
		closeRegistModal() {
			this.modalAccountRegist = false;
			this.createBuyHandler();
		},
		closeBuyModal() {
			this.modalBuy = false;
			this.reset();
			this.loadPrivateDealList();
		},
		tutorialHandler() {
			if (!Cookies.get(this.$route.name + '_tutorial')) {
				this.showTutorial = true;
			}
		},
	},
	mounted() {
		this.tutorialHandler();
	},
};
</script>
<style scoped></style>
